export const fetcher = (url) =>
  fetch(url, {
    headers: {
      Site: process.env.NEXT_PUBLIC_SITE,
    },
  }).then((res) => res.json());
